
const ACTION_PREFIX = 'MENTEE/PROFILE_SHARE';

export const FILE_UPLOAD_INIT = `${ACTION_PREFIX}/FILE_UPLOAD_INIT`;
export const FILE_UPLOAD_DONE = `${ACTION_PREFIX}/FILE_UPLOAD_DONE`;
export const FILE_UPLOAD_ERROR = `${ACTION_PREFIX}/FILE_UPLOAD_ERROR`;

export function fileUploadError(payload) {
  return { type: FILE_UPLOAD_ERROR, payload };
}

const initialState = {
  loading: false,
  error: null,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FILE_UPLOAD_INIT:
      return {
        ...state,
        loading: true,
        erro: null,
      };
    case FILE_UPLOAD_DONE:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case FILE_UPLOAD_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
